import { render, staticRenderFns } from "./edit_focus.vue?vue&type=template&id=4bc50a93"
import script from "./edit_focus.vue?vue&type=script&lang=js"
export * from "./edit_focus.vue?vue&type=script&lang=js"
import style0 from "./edit_focus.vue?vue&type=style&index=0&id=4bc50a93&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports